import React from "react";
import { connect } from "react-redux";
import { AppState } from "../../reducers";
import { Link } from "react-scroll";
import QuestioNumber from "./QuestionNumber";

export const QuestionList = (props: any) => {
  const { questions, setQIndex, flags, answers, preview } = props;
  return (
    <div className="question-list">
      {questions.map((question: any, index: number) => {
        let val = "no";
        let values = question.question_post_title.split("Q");
        if (values && values.length > 0) {
          if (values[1] && val === "no") {
            if (
              values[1].length > 4 &&
              !values[1].includes("(") &&
              !values[1].includes(")")
            ) {
              val =
                "Q" +
                values[1]
                  .replace("Q", " ")
                  ?.split(" ")
                  ?.map((s: string) => s?.charAt(0).toUpperCase())
                  ?.join("");
            } else {
              val = values[1];
            }
          }
        }
        return (
          <div key={index}>
            {preview ? (
              <Link
                to={"ref_" + question._id}
                spy={true}
                smooth={true}
                key={index}
              >
                <QuestioNumber
                  questionId={question._id}
                  onClick={() => setQIndex(index)}
                  ans={answers[question._id].ans}
                  value={val.trim()}
                  index={index}
                  currentIndex={props.idx}
                  isFlagged={flags.includes(question._id)}
                />
              </Link>
            ) : (
              <QuestioNumber
                questionId={question._id}
                onClick={() => setQIndex(index)}
                ans={answers[question._id].ans}
                value={val.trim()}
                index={index}
                currentIndex={props.idx}
                isFlagged={flags.includes(question._id)}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

const mapStateToProps = (store: AppState) => {
  return {
    flags: store.quiz.flags,
    answers: store.quiz.answers,
  };
};
export default connect(mapStateToProps)(QuestionList);
